import { useMemo } from "react";
import { Area, AreaChart, ResponsiveContainer } from "recharts";

interface KPISparklineProps {
  data: number[];
  color?: "green" | "amber" | "red" | "default";
  height?: number;
}

const COLOR_MAP = {
  green: "hsl(142.1 76.2% 36.3%)",
  amber: "hsl(38 92% 50%)",
  red: "hsl(0 84.2% 60.2%)",
  default: "hsl(var(--primary))",
};

export function KPISparkline({ data, color = "default", height = 32 }: KPISparklineProps) {
  const chartData = useMemo(() => {
    return data.map((value, index) => ({ value, index }));
  }, [data]);

  const strokeColor = COLOR_MAP[color];
  const fillColor = strokeColor;

  if (data.length < 2) {
    return (
      <div 
        className="flex items-center justify-center text-xs text-muted-foreground"
        style={{ height }}
      >
        No trend data
      </div>
    );
  }

  return (
    <div style={{ height, width: "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id={`gradient-${color}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={fillColor} stopOpacity={0.3} />
              <stop offset="100%" stopColor={fillColor} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="value"
            stroke={strokeColor}
            strokeWidth={1.5}
            fill={`url(#gradient-${color})`}
            dot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
